<template>
  <v-container>
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-text-field
        v-model="vehicle.vehicleMake"
        :rules="[validationRules.required]"
        label="Make"
      />
      <v-text-field
        v-model="vehicle.vehicleModel"
        :rules="[validationRules.required]"
        label="Model"
      />
      <v-autocomplete
        v-model="vehicle.vehicleState"
        :rules="[validationRules.required]"
        :items="states"
        label="State/Province"
      />
      <v-text-field
        v-model="vehicle.vehicleLicensePlate"
        :rules="[validationRules.required]"
        label="License Plate"
      />
      <v-btn
        :disabled="!valid"
        @click="submit()"
      >
        Submit
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

export default {
  name: 'VehicleForm',
  data () {
    return {
      valid: false,
      vehicle: {
        vehicleState: null,
        vehicleLicensePlate: null,
        vehicleMake: null,
        vehicleModel: null
      },
      states: [
        // u.s.
        'Alabama', 'Alaska', 'American Samoa', 'Arizona',
        'Arkansas', 'California', 'Colorado', 'Connecticut',
        'Delaware', 'District of Columbia', 'Federated States of Micronesia',
        'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
        'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
        'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
        'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
        'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
        'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
        // canada
        'Ontario', 'Quebec', 'British Columbia', 'Alberta', 'Manitoba',
        'Saskatchewan', 'Nova Scotia', 'New Brunswick', 'Newfoundland and Labrador',
        'Prince Edward Island', 'Northwest Territories', 'Nunavut', 'Yukon',
        // mexico
        'Chihuahua', 'Sonora', 'Coahuila', 'Durango', 'Oaxaca', 'Tamaulipas',
        'Jalisco', 'Zacatecas', 'Baja California Sur', 'Chiapas', 'Veracruz',
        'Baja California', 'Nuevo León', 'Guerrero', 'San Luis Potosí', 'Michoacán',
        'Sinaloa', 'Campeche', 'Quintana Roo', 'Yucatán', 'Puebla', 'Guanajuato',
        'Nayarit', 'Tabasco', 'México', 'Hidalgo', 'Querétaro', 'Colima',
        'Aguascalientes', 'Morelos', 'Tlaxcala', 'Mexico City'
      ]
    }
  },
  methods: {
    ...mapActions({
      createVehicle: 'vehicles/createVehicle'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        this.createVehicle(this.vehicle).then(() => {
          // reset form
          this.$refs.form.reset()
          this.$emit('close')
        })
      }
    }
  }
}
</script>
